// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function() {
  if (typeof window.CustomEvent === 'function') return false

    function CustomEvent(event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined }
      var evt = document.createEvent('CustomEvent')
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
      return evt
    }

    CustomEvent.prototype = window.Event.prototype

    window.CustomEvent = CustomEvent
  })()

// import external dependencies
import 'jquery';
import 'slick-carousel';
import { CountUp } from './external/countUp';

// Import everything from autoload
import './autoload/_foundation.js'; import './autoload/jquery.waypoints.min.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import videos from './routes/videos';
import templateGlossary from './routes/templateGlossary';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  videos,
  templateGlossary,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

/* Main Javascript Functions */
jQuery(document).ready(function ($) {

  /* Expanding Cards */
  if ($('.expand_cards__list').length > 0) {
    $(document).on('mouseenter', '.expand_cards__list > li', function(e){
      console.log('mouseenter');
      var active = $(this).hasClass('active'),
          id = $(this).attr('data-id');

      if (!active) {
        $('.expand_cards__list[data-id="'+id+'"] > .active').removeClass('active');
        $(this).addClass('active');
      }
    });
  }

  /* Comparison Slider */
  if ($('.comparison_slider').length > 0) {

    $(document).on('click', '.comparison_slide > a', function(e){
      e.preventDefault();
      var active = $(this).hasClass('active'),
          id = $(this).attr('data-id'),
          column = $(this).attr('data-column');

      if (!active) {
        $('.comparison_slide > a[data-id="'+id+'"].active').removeClass('active');
        $('.comparison_slide[data-id="'+id+'"].active').removeClass('active');
        $('.comparison_chart__column[data-id="'+id+'"].active').removeClass('active');
        $(this).addClass('active');
        $('.comparison_slide[data-id="'+id+'"][data-column="'+column+'"]').addClass('active');
        $('.comparison_chart__column[data-id="'+id+'"][data-column="'+column+'"]').addClass('active');
      }
    });

    $('.comparison_slider').each(function(e) {
      var csid = $(this).attr('data-id');

      $(this).slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        lazyLoad: 'ondemand',
        centerMode: true,
        ininite: false,
        centerPadding: '20%',
      });

      $(document).on('click touchend', '.comparison_slider[data-id="'+csid+'"] .slick-slide', function (e) {
        console.log('tocuhed');
        var index = $(this).data("slick-index");
        if ($('.comparison_slider[data-id="'+csid+'"]').slick('slickCurrentSlide') !== index) {
            $('.comparison_slider[data-id="'+csid+'"]').slick('slickGoTo', index);
        }
      });
    });
  }

  /* Guide Slider */
  if ($('.guide_slider__list').length > 0) {
    $('.guide_slider__list').each(function(e) {
      var qsid = $(this).attr('data-id');

      $(this).slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        lazyLoad: 'ondemand',
        infinite: true,
        appendDots: $('.guide_slider__pagination_wrap[data-id="'+qsid+'"] .slide-m-dots'),
        prevArrow: $('.guide_slider__pagination_wrap[data-id="'+qsid+'"] .slide-m-prev'),
        nextArrow: $('.guide_slider__pagination_wrap[data-id="'+qsid+'"] .slide-m-next'),
      });
    });
  }

  /* Featured Article Slider */
  if ($('.featured-slider').length > 0) {
    $('.featured-slider').each(function(e) {
      $(this).slick({
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        lazyLoad: 'ondemand',
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        ],
      });
    });
  }

  if ($('.featured-slider-c').length > 0) {
    $('.featured-slider-c').each(function(e) {
      $(this).slick({
        arrows: true,
        slidesToShow: 6,
        slidesToScroll: 3,
        dots: false,
        lazyLoad: 'ondemand',
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        ],
      });
    });
  }

  /* Quotes Slider */
  if ($('.quotes_slider__list').length > 0) {
    $('.quotes_slider__list').each(function(e) {
      var qsid = $(this).attr('id');
      $(this).slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        lazyLoad: 'ondemand',
        appendDots: $('.quote_slider__pagination_wrap[data-id="'+qsid+'"] .slide-m-dots'),
        prevArrow: $('.quote_slider__pagination_wrap[data-id="'+qsid+'"] .slide-m-prev'),
        nextArrow: $('.quote_slider__pagination_wrap[data-id="'+qsid+'"] .slide-m-next'),
      });
    });
  }

  /* Scroll to top functionality (global) */
  $(document).on('click', '.scroll-to-top', function(e){
    e.preventDefault();
    window.scroll({top: 0, behavior: "smooth"});
  });

  /* Content Search/Filter Functions */
  var typingTimer,
  doneTypingInterval = 500,
  categories = 'all',
  order = 'DESC',
  articleList = [];

  if ($('.article_list').length > 0) {
    $('.article_list').each(function(){
      var id = $(this).attr('data-id');
      articleList[id] = $('.article_list[data-id="'+id+'"]').html();
    });
  }

  function regenArticles(id) { 
    
    var $status = $('.content_search__pagination_wrap[data-id="'+id+'"] .slick-counter');
    var $slickElement = $('.article_list[data-id="'+id+'"]');
    
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + ' of ' + slick.slideCount);
    });

    var count = $('.article_list[data-id="'+id+'"] .filtered').length;
    
    if (order == 'ASC') {
      var results = $('.article_list[data-id="'+id+'"]');
      results.children().each(function(i,div){results.prepend(div)});
    }

    if (count >= 1) {

      $('.filter__none[data-id="'+id+'"]').hide(); 

      if ($('.article_list[data-id="'+id+'"]').hasClass('al__narrow_layout')) {
        $('.article_list[data-id="'+id+'"]').slick({
          arrows: true,
          slidesPerRow: 3,
          dots: true,
          rows: 3,
          adaptiveHeight: true,
          lazyLoad: 'ondemand',
          appendDots: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-dots'),
          prevArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-prev'),
          nextArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-next'),
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesPerRow: 3,
              rows: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesPerRow: 2,
              rows: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesPerRow: 1,
              rows: 3,
            },
          },
          ],
        });
      } else if ($('.article_list[data-id="'+id+'"]').hasClass('al__short_layout')) {
        $('.article_list[data-id="'+id+'"]').slick({
          arrows: true,
          slidesPerRow: 3,
          dots: true,
          rows: 1,
          adaptiveHeight: true,
          lazyLoad: 'ondemand',
          appendDots: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-dots'),
          prevArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-prev'),
          nextArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-next'),
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesPerRow: 3,
              rows: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesPerRow: 2,
              rows: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesPerRow: 1,
              rows: 1,
            },
          },
          ],
        });
      } else if ($('.article_list[data-id="'+id+'"]').hasClass('vacancy_list')) {
        $('.article_list[data-id="'+id+'"]').slick({
          arrows: true,
          slidesPerRow: 1,
          dots: true,
          rows: 9,
          adaptiveHeight: true,
          lazyLoad: 'ondemand',
          appendDots: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-dots'),
          prevArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-prev'),
          nextArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-next'),
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesPerRow: 1,
              rows: 9,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesPerRow: 1,
              rows: 6,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesPerRow: 1,
              rows: 3,
            },
          },
          ],
        });
      } else if ($('.article_list[data-id="'+id+'"]').hasClass('al__list-no-image_layout')) {  
        $('.article_list[data-id="'+id+'"]').slick({
          arrows: true,
          slidesPerRow: 1,
          dots: true,
          rows: 10,
          adaptiveHeight: true,
          lazyLoad: 'ondemand',
          appendDots: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-dots'),
          prevArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-prev'),
          nextArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-next'),
          draggable: false,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesPerRow: 1,
              rows: 10,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesPerRow: 1,
              rows: 10,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesPerRow: 1,
              rows: 10,
            },
          },
          ],
        });
      } else {  
        $('.article_list[data-id="'+id+'"]').slick({
          arrows: true,
          slidesPerRow: 2,
          dots: true,
          rows: 3,
          adaptiveHeight: true,
          lazyLoad: 'ondemand',
          appendDots: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-dots'),
          prevArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-prev'),
          nextArrow: $('.content_search__pagination_wrap[data-id="'+id+'"] .slide-m-next'),
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesPerRow: 2,
              rows: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesPerRow: 2,
              rows: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesPerRow: 1,
              rows: 3,
            },
          },
          ],
        });
      }
      
    } else {
      $('.filter__none[data-id="'+id+'"]').show();
    }
  }

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;',
  };
  
  function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=/]/g, function (s) {
      return entityMap[s];
    });
  }
  
  function textFilter(id) {
    var text = $('input[name="filter_search"][data-id="'+id+'"]').val(),
    results = $('.article_list[data-id="'+id+'"] .filtered');
    if (text && text !== '') {
      text = text.toLowerCase();
      $('.article_list[data-id="'+id+'"] .filtered').each(function(){
        var filter = $(this).attr('data-title');            
        if (filter.indexOf(text) == -1) {
          $(this).remove();
        }
      }).promise().done( function(){ 
        $('.filter__none[data-id="'+id+'"] h3').show();
        $('.filter__none[data-id="'+id+'"] .filter__none_text').html(escapeHtml(text));
        regenArticles(id);
      } );
        //Added Else if mobile search
      } else {
        $('.filter__none[data-id="'+id+'"] h3').hide();
        $('.filter__none[data-id="'+id+'"] .filter__none_text').html('');
        regenArticles(id);
      }          
    }

    function removeItemAll(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    } 

    function findCommonElement(array1, array2) {
      for(let i = 0; i < array1.length; i++) {
        for(let j = 0; j < array2.length; j++) {
          if(array1[i] === array2[j]) {
            return true;
          }
        }
      }
      return false; 
    }

    function filterContent(id) {
      if ($('.article_list[data-id="'+id+'"]').hasClass('slick-initialized')) {
        $('.article_list[data-id="'+id+'"]').slick('unslick');
      }
    //console.log(articleList);
    $('.article_list[data-id="'+id+'"]').html(articleList[id]);
    
    if (categories != 'all') {                  
      $('.article_list[data-id="'+id+'"] .filtered').each(function(){
        if (categories && categories != 'all') {
          var cat = $(this).attr('data-cat');
          
          if (cat && cat.trim() !== '') {
            var t = cat.split(',');

            for(var x=0; x<t.length; ++x) {
              if (categories.indexOf(t[x]) == -1) {
                $(this).remove(); break;
              }
            }
          } else {
            $(this).remove();
          }
        }
      }).promise().done( function(){ 
        textFilter(id);
      } );
    } else {
      textFilter(id);
    }
  } 

  $(document).on('keyup', 'input[name="filter_search"]', function(e){
    clearTimeout(typingTimer);
    var id = $(this).attr('data-id');
    typingTimer = setTimeout(function(){filterContent(id);}, doneTypingInterval);
  });

  $(document).on('keydown', 'input[name="filter_search"]', function(e){
    clearTimeout(typingTimer);
  });
  
  $(document).on('change', 'select[name="category_filter"]', function(){
    console.log('changed');

    var filter = $(this).find(":selected").val(),
    id = $(this).attr('data-id');

    categories = filter;
    filterContent(id);
  });

  $(document).on('click', '.cf__filter', function(e){
    e.preventDefault();
    var active = $(this).hasClass('active'),
    filter = $(this).attr('data-filter'),
    radio = $(this).hasClass('cf__radio'),
    id = $(this).attr('data-id');
    
    if (active) {
        // Nothing
      } else {
        $(this).parent().find('.active') .removeClass('active');
        categories = filter;
        
        $(this).addClass('active');
      }
      
    //console.log(format);
    
    filterContent(id);
  });  

  $(document).on('click', '.scroll-next .slide-m-next', function(){
    //console.log('clicked');
    var id = $(this).attr('data-id');
    $([document.documentElement, document.body]).animate({
      scrollTop: $('#'+id).offset().top,
    }, 1000);
  });

  if ($('.article_list').length > 0) {
    $('.article_list').each(function(){
      var id = $(this).attr('data-id');
      filterContent(id);
    });
  }

  regenArticles();
});


// WEBPACK FOOTER //
// ./scripts/main.js